<mat-dialog-content>
  <div [ngClass]="resizeClass" class="w100">
    <div class="flex-center-center flex-direction-column w100" style="margin-top: -10px">
      @if (titleDialog) {
        <mat-card-title>
          {{ titleDialog }}
        </mat-card-title>
      }
      @if (data.subTitle) {
        <mat-card-subtitle>
          {{ data.subTitle }}
        </mat-card-subtitle>
      }
    </div>
    <div class="flex-center-center flex-direction-row w100">

      @for (value of values; track value; let i = $index) {
        <mat-card class="size-card-extended-info">
          <mat-card-header>
            @if (value.title!=null) {
              <mat-card-subtitle>
                @if (value.title.traduction != null) {
                  {{ value.title.traduction!|translate }}
                } @else if (value.title.sensorTraduction) {
                  {{ (value.title.sensorTraduction!|sensorDataTraduction$)|async }}
                } @else {
                  {{ value.title.value }}
                }
                @if (data.removeValues==true) {
                  <button mat-icon-button color="accent" (click)="removeValue(i)">
                    <mat-icon>clear</mat-icon>
                  </button>
                }
              </mat-card-subtitle>
            }
            @if (value.subTitle!=null) {
              <mat-card-subtitle>
                @if (value.subTitle.traduction != null) {
                  {{ value.subTitle.traduction!|translate }}
                } @else if (value.subTitle.sensorTraduction) {
                  {{ (value.subTitle.sensorTraduction!|sensorDataTraduction$)|async }}
                } @else {
                  {{ value.subTitle.value }}
                }
                @if (data.removeValues==true) {
                  <button mat-icon-button color="accent" (click)="removeValue(i)">
                    <mat-icon>clear</mat-icon>
                  </button>
                }
              </mat-card-subtitle>
            }
          </mat-card-header>
          <mat-card-content>
            <mat-card-subtitle style="font-weight: bold;font-size: large;overflow-wrap: break-word;">
              @if (value.value!=null) {
                @if (value.value.traduction!=null) {
                  {{ value.value.traduction!|translate }}
                } @else {
                  {{ value.value.value }}
                }
              }
            </mat-card-subtitle>
          </mat-card-content>
        </mat-card>
      }
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="flex-end-center">
  <button mat-flat-button color="accent" (click)="closeDialog()">
    <mat-icon>clear</mat-icon>
  </button>
  @if (data.removeValues==true) {
    <button mat-flat-button color="primary" (click)="sendValue()">
      <mat-icon>check</mat-icon>
    </button>
  }
  @if (data.actions) {
    @for (action of data.actions; track action) {
      <button mat-flat-button [color]="action.color" (click)="clickAction(action)" [disabled]="action.disabled">
        @if (action.icon) {
          <mat-icon>{{ action.icon }}</mat-icon>
        } @else {
          <mat-icon [svgIcon]="action.iconSvg!"></mat-icon>
        }
      </button>
    }
  }
</mat-dialog-actions>